import React from 'react';

type ClockProps = {
  className?: string;
};

/**
 * Icono de reloj para el TimerOverlay (V4 D3 / P10).
 *
 * Sigue el patrón canónico de `NotifIcon`, `SettingsIcon`, `TakePhotoIcon`:
 * - SVG sin colores hardcoded — usa `currentColor` para que el padre
 *   (`ButtonIcon` styled) controle el color via CSS.
 * - 24×24 viewBox para alinear con el grid del resto de iconos del header.
 *
 * Nota: el estado activo (verde, badge pulsante) se gestiona en el
 * componente padre (`TimerOverlay`) renderizando un `ActiveDot` como
 * children del `ButtonIcon`, no aquí.
 */
export const Clock = ({ className }: ClockProps): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15 14" />
    </svg>
  );
};
